import { FC } from 'react'
import classNames from 'classnames'
import { Button, ButtonGroupProps } from 'semantic-ui-react'

import './index.scss'

export const ToggleGroup: FC<ButtonGroupProps> = ({ className, ...props }) => (
  <Button.Group className={classNames('populus-toggle-group', className)} {...props} />
)
